import React from "react";
import { useNavigate } from "react-router-dom";
import { LuLogOut, LuUserRound } from "react-icons/lu";

const Navbar2 = () => {
  const navigate = useNavigate();

  return (
    <nav className="fixed top-0 inset-x-0 md:left-56 z-40 h-16 bg-night-900/80 backdrop-blur-xl border-b border-brand-teal/12 shadow-[0_8px_32px_-16px_rgba(0,0,0,0.7)]">
      <div className="h-full flex items-center justify-between pl-16 pr-4 md:px-6">
        {/* Brand (mobile only — desktop brand is in the sidebar) */}
        <span className="md:hidden font-extrabold text-lg text-main-font tracking-tight whitespace-nowrap">
          Rewarded&nbsp;<span className="text-gradient-teal">Play</span>
        </span>
        <div className="hidden md:block" />

        {/* Right side */}
        <div className="flex items-center gap-2 sm:gap-3">
          <div className="flex items-center gap-2 rounded-xl bg-main-bg border border-main-border pl-1.5 pr-3 py-1.5">
            <span className="w-7 h-7 rounded-lg bg-gradient-to-br from-teal-500 to-cyan-500 text-white flex items-center justify-center shrink-0">
              <LuUserRound size={16} />
            </span>
            <span className="text-sm font-semibold text-main-font hidden sm:block">
              Admin
            </span>
          </div>

          <button
            onClick={() => navigate("/logout")}
            className="flex items-center gap-2 rounded-xl border border-main-border bg-main-bg px-3 sm:px-4 py-2 text-sm font-medium text-main-delete transition-all duration-200 hover:border-main-delete hover:bg-main-delete/10 hover:-translate-y-0.5 active:translate-y-0"
          >
            <LuLogOut size={17} />
            <span className="hidden sm:block">Logout</span>
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar2;
